import React from "react";
import ConditionChecklist from "./condition-checklist";
import { Q7_CONDITIONS, EATING_DISORDER_TYPES } from "../../data/eligibility-rules";

// Q7 — "Do you have any of the following health conditions?" The doc presents this as
// ONE question with a single flat list (not split across multiple screens); Q7_CONDITIONS
// is already in the doc's exact order, so this screen just renders it directly.
export default function Step8({ formData, setFormData, onBack, goToStep }) {
  return (
    <ConditionChecklist
      formData={formData}
      setFormData={setFormData}
      onBack={onBack}
      goToStep={goToStep}
      title="Do you have any of the following health conditions?"
      options={Q7_CONDITIONS}
      formDataKey="q7Conditions"
      nextStepId="8f"
      nestedQuestion={{
        triggerKey: "eatingDisorder",
        formDataKey: "eatingDisorderType",
        render: (value, onChange) => (
          <div className="flex flex-col gap-2">
            <p className="text-gray-700 text-sm font-medium">
              What type of eating disorder have you been diagnosed or treated for?
            </p>
            {EATING_DISORDER_TYPES.map((type) => (
              <label
                key={type.key}
                className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm"
              >
                <input
                  type="radio"
                  name="eatingDisorderType"
                  checked={value === type.key}
                  onChange={() => onChange(type.key)}
                  className="h-4 w-4 accent-sky-400 cursor-pointer"
                />
                <span>{type.label}</span>
              </label>
            ))}
            {value === "bed" && (
              <p className="text-xs text-gray-500 mt-1">
                While BED is sometimes treated off-label with GLP-1s, active anorexia or bulimia are
                strict contraindications due to the appetite-suppressing nature of the drug.
              </p>
            )}
          </div>
        ),
      }}
    />
  );
}
